/**
 * Recursos da tela inicial (Dashboard, a "Home") que o ponteiro de uma novidade sabe apontar. Ver
 * `spotlightTargets.js`.
 *
 * A tela inicial é o Lucas (assistente de suporte) mais alguns cartões do estado da conta. Nada
 * nela tem URL: abrir o Lucas, o drawer de avisos e a conversa é estado do React. No shell
 * embutido o corpo (agentes, cartões editoriais, tarefas, cobrança) não é desenhado, e uma conta
 * sem pendência de cobrança nunca vê o aviso de fatura nem a lista de tarefas: o ponteiro espera.
 */

const LUCAS = "Lucas (assistente de suporte)";
const CARTOES = "Cartões da conta";

export const DASHBOARD_TARGETS = [
  {
    key: "dashboard.lucas-composer",
    navKey: "dashboard",
    group: LUCAS,
    label: "Campo de pergunta do Lucas",
    path: "/",
    requires: "page",
    hint: "A caixa grande no centro: a pessoa pergunta como resolver algo e o Lucas responde com a Central de Ajuda. Some em conta com fatura vencida.",
  },
  {
    key: "dashboard.lucas-suggestions",
    navKey: "dashboard",
    group: LUCAS,
    label: "Atalhos de perguntas frequentes",
    path: "/",
    requires: "page",
    hint: "Os atalhos abaixo do campo; se houve falha de envio recente, um deles já traz o motivo. Ficam recolhidos enquanto uma conversa está aberta.",
  },
  {
    key: "dashboard.notices-button",
    navKey: "dashboard",
    group: LUCAS,
    label: "Botão Avisos",
    path: "/",
    requires: "page",
    hint: "Abre a central de avisos com os comunicados da TouchWorks, lidos ou não. No lugar dele aparece o X de fechar enquanto o Lucas está aberto.",
  },
  {
    key: "dashboard.alert-pill",
    navKey: "dashboard",
    group: CARTOES,
    label: "Aviso de fatura vencida ou fim do teste",
    path: "/",
    requires: "data",
    hint: "A pílula no topo mostra o problema mais urgente da conta e leva a pagar ou escolher um plano. Só aparece com fatura vencida ou teste acabando.",
  },
  {
    key: "dashboard.agent-readiness-card",
    navKey: "dashboard",
    group: CARTOES,
    label: "Cartão Agentes do escritório",
    path: "/",
    requires: "data",
    minLevel: 50,
    hint: "Mostra o próximo passo da configuração dos agentes (criar agentes, conectar o WhatsApp). Só para administradores, fora do shell embutido.",
  },
  {
    key: "dashboard.task-list",
    navKey: "dashboard",
    group: CARTOES,
    label: "Lista Suas tarefas",
    path: "/",
    requires: "data",
    hint: "Reúne o que está pendente na conta; hoje só a fatura vencida. Uma conta em dia não vê a lista.",
  },
  {
    key: "dashboard.editorial-cards",
    navKey: "dashboard",
    group: CARTOES,
    label: "Cartões de novidades e tutoriais",
    path: "/",
    requires: "data",
    hint: "Artigos e novidades escolhidos pela TouchWorks. Só aparecem quando há conteúdo publicado, fora do shell embutido.",
  },
  {
    key: "dashboard.billing-status",
    navKey: "dashboard",
    group: CARTOES,
    label: "Plano e cobrança (rodapé)",
    path: "/",
    requires: "data",
    minLevel: 50,
    hint: "O plano da conta e se está em dia, com atalho para o Billing. Só para quem pode ver a cobrança.",
  },
  {
    key: "dashboard.help-articles-link",
    navKey: "dashboard",
    group: CARTOES,
    label: "Link Ver todos os artigos",
    path: "/",
    requires: "page",
    hint: "Abre a Central de Ajuda com todos os artigos e guias de uso. Fica no rodapé da tela, fora do shell embutido.",
  },
];
